import i18n from 'i18next';
import { useEffect, useState } from 'react';
import { getVendorPortCodes } from '../../../redux/POV/POVEffects';
import { getShipmentPortCodes } from '../../../redux/shipment/ShipmentEffects';
import FormSelectBox from '../Inputs/FormSelectBox';

const PortCodeSelector = ({
  form,
  placeholder = i18n.t('translation:default.fields.portType.placeholder'),
  label = i18n.t('translation:default.fields.portType.label'),
  rules = [],
  name,
  editMode,
  portType,
  mode = '',
  handleChange = () => {},
  countryCode,
  portCity,
  handleValueRender = (row) => Number(row.value),
  isVendor = false,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setOptions([]);
    form?.resetFields([name]);
    if (portType) {
      getStatusList(portType, countryCode, portCity);
    }
  }, [portType, countryCode, portCity]);

  const getStatusList = async (portType, countryCode, portCity) => {
    try {
      setLoading(true);
      const fetchPortCodes = isVendor ? getVendorPortCodes : getShipmentPortCodes;

      const params = isVendor
        ? { portType, portCountryCode: countryCode, portCity }
        : { PortType: portType, PortCountryCode: countryCode };

      const { data } = await fetchPortCodes(params);

      const options = data.map((row) => ({
        label: row.text,
        value: handleValueRender(row),
      }));
      setOptions(options);
      setLoading(false);
    } catch {
      setOptions([]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      key={portType}
      loading={loading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin="mb-0"
      rules={rules}
      name={name}
      mode={mode}
      editMode={editMode}
      onChange={handleChange}
    />
  );
};

export default PortCodeSelector;
